import { createShapeNormalizer } from '@change-corgi/fcm/normalizers';

import { defineFcm } from '../shared/factory';

export const FCM_PSF_SHARE_SLIDE_UP_EDITABLE_SHARE_COPY_EXPERIMENT = defineFcm(
	'psf_share_slide_up_editable_share_copy_experiment',
)
	.asJson(
		createShapeNormalizer({
			type: 'object',
			shape: {
				enabled: { type: 'boolean', optional: true },
			},
		}),
	)
	.withDefault({ enabled: false })
	.toConfig({
		owner: 'squad-platypus',
		scope: 'corgi-front-end',
		context: 'psf promote-or-share share slide-up',
		description:
			'Gates the editable share copy experiment on the PSF promote-or-share share slide-up, letting users edit the pre-filled share message text before sharing.',
		import: false,
		template: {
			enabled: true,
		},
	});
